import { Roles } from "./Roles";

export interface IRole {
    roleId: Roles;
    code: string;
    label: string;
}
